import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

/**
 * Keyword Count with Organic Traffic
 */
const AtlasV2OrganicTrafficKeywordSplineChart = () => {
  return (
    <AtlasV2ComparableSplineChart
      indexName="traffic"
      fieldName="searchTerm"
      title="Keyword Count with Organic Traffic"
      requestBuilder={(builder) => builder.addConditionRangeFilter('organicClicks', 1)}
    />
  );
};

export default AtlasV2OrganicTrafficKeywordSplineChart;
